import React, {ChangeEvent, useEffect, useState} from 'react';

import {Content, ContentSection} from 'components';
import Sidebar from 'containers/sidebar';
import {
  Button,
  Form,
  FormFields,
  FormTextarea,
  FormInput,
  Heading,
  Toast,
} from 'components/ultra';

import {useSendContactFormMutation} from './graphql/Contact';
import {ButtonRow} from './styles';

export function Contact() {
  const defaultFormValues = {email: '', message: '', name: ''};
  const [formValues, setFormValues] = useState(defaultFormValues);
  const [validInput, setValidInput] = useState(false);
  const [successToast, setSuccessToast] = useState(false);
  const [errorToast, setErrorToast] = useState(false);

  const [sendContactForm, {error, loading, data}] = useSendContactFormMutation({
    variables: {
      payload: formValues,
    },
    onCompleted: () => {
      setSuccessToast(true);
      setFormValues(defaultFormValues);
    },
    onError: () => setErrorToast(true),
  });

  useEffect(() => {
    const {email, message, name} = formValues;
    const valid =
      name !== '' &&
      message !== '' &&
      email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/) !== null;

    valid && !validInput && setValidInput(true);
    !valid && validInput && setValidInput(false);
  }, [formValues, validInput]);

  function handleChangeInputValue(
    evt: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) {
    setFormValues({
      ...formValues,
      [evt.currentTarget.name]: evt.currentTarget.value,
    });
  }

  return (
    <>
      <Sidebar />
      <Content>
        {successToast && (
          <Toast
            message="Thank you, we received your message."
            onDismiss={() => setSuccessToast(false)}
          />
        )}
        {errorToast && (
          <Toast
            message="Your message could not be sent. Please try again."
            status="error"
            onDismiss={() => setErrorToast(false)}
          />
        )}
        <ContentSection footerWidth>
          <Heading element="h1" gradient={true}>
            Hello there,
          </Heading>
          <Heading>
            Send us a message and we'll get back to you as soon as possible.
          </Heading>
        </ContentSection>
        <ContentSection footerWidth>
          <Form
            onSubmit={evt => {
              evt.preventDefault();
              if (!validInput) {
                return;
              }
              sendContactForm();
            }}
          >
            <FormFields>
              <FormInput
                name="name"
                label="Name"
                value={formValues.name}
                onChange={handleChangeInputValue}
              />
              <FormInput
                name="email"
                label="Email"
                type="email"
                value={formValues.email}
                onChange={handleChangeInputValue}
              />
              <FormTextarea
                fullwidth
                name="message"
                label="Message"
                value={formValues.message}
                onChange={handleChangeInputValue}
              />
            </FormFields>
            <ButtonRow>
              <Button
                type="button"
                onClick={() => setFormValues(defaultFormValues)}
              >
                Reset
              </Button>
              <Button
                type="submit"
                severity="inverse"
                disabled={!validInput}
                loading={loading}
              >
                Send
              </Button>
            </ButtonRow>
          </Form>
        </ContentSection>
      </Content>
    </>
  );
}
